export default __webpack_public_path__ + "static/media/thei.d2119f01.png";